import { useState } from "react";
import { Outlet } from "react-router-dom";

export default function EquipmentProcessSettings() {
  const [itemObj, setItemObj] = useState({}); //設定當前點了table哪一筆tr物件(CRUD)
  const [action, setAction] = useState(""); //設定當前是做哪個動作(CRUD)
  const [currentCompanySeq, setCurrentCompanySeq] = useState(""); // 當前公司序號
  const [selectPlaceList, setSelectPlaceList] = useState([]); // 選擇公司場所
  const [currentCompanyName, setCurrentCompanyName] = useState(""); // 當前公司名稱

  return (
    <Outlet
      context={{
        itemObj,
        setItemObj,
        action,
        setAction,
        currentCompanySeq,
        setCurrentCompanySeq,
        selectPlaceList,
        setSelectPlaceList,
        currentCompanyName,
        setCurrentCompanyName,
      }}
    />
  );
}
